import { useAtomValue } from "jotai";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { activeObjectsState } from "./JotaiAtoms";

type SlackMentionProps = {
  type: "broadcast" | "subteam";
  value: string;
  fontSize?: number;
};

export function SlackMention({ type, value, fontSize }: SlackMentionProps) {
  const theme = useTheme();
  const objects = useAtomValue(activeObjectsState);

  const getMentionText = (): string => {
    if (type === "broadcast") {
      // Extract the broadcast type (here, channel, everyone)
      // Format: <!here> or <!channel|general>
      const mention = value.slice(2, -1).split("|").slice(-1)[0];
      return `@${mention}`;
    } else {
      // type === "subteam"
      // Format: <!subteam^S01234567> or <!subteam^S01234567|handle>
      const parts = value.slice(0, -1).split("^");
      if (parts.length < 2) {
        return value; // Fallback to original if format is unexpected
      }

      const idPart = parts[1].split("|")[0]; // Get ID without handle

      // Try to resolve the ID using objects
      // Objects are keyed like "slack:usergroup:S01234567"
      const objectKey = `slack:usergroup:${idPart}`;

      if (objects && objects[objectKey]) {
        const obj = objects[objectKey];
        console.log(obj);
        return `@${obj.name || obj.full_name || idPart}`;
      }

      // Fallback: use handle if provided, otherwise use ID
      const handleOrId = parts[1].split("|")[1] || idPart;
      return `@${handleOrId}`;
    }
  };

  return (
    <Typography
      component="span"
      fontSize={fontSize}
      sx={{
        whiteSpace: "pre-wrap",
        fontWeight: 600,
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(138, 180, 248, 0.16)"
            : "rgba(25, 103, 210, 0.12)",
        color: theme.palette.mode === "dark" ? "#8ab4f8" : "#1967d2",
        px: 0.5,
        py: 0.125,
        borderRadius: "3px",
      }}
    >
      {getMentionText()}
    </Typography>
  );
}
